import { render, staticRenderFns } from "./GroupSiteKeywords.vue?vue&type=template&id=736026a3&"
import script from "./GroupSiteKeywords.vue?vue&type=script&lang=js&"
export * from "./GroupSiteKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports